import { render } from "./OverallTrackingHistory.vue?vue&type=template&id=521127e6&scoped=true"
import script from "./OverallTrackingHistory.vue?vue&type=script&lang=js"
export * from "./OverallTrackingHistory.vue?vue&type=script&lang=js"

import "./OverallTrackingHistory.vue?vue&type=style&index=0&id=521127e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521127e6"]])

export default __exports__